import React, { useEffect, useState, useCallback } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { startOfYear } from 'date-fns';
import { format } from 'date-fns-tz';
import { startOfDay } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { LatLngTuple } from 'leaflet';
import FilterBar, { IncFilterOpsType } from '../../components/FilterBar';
import { useStyles } from './styles';
import api from '../../services/api';
import { RecordsResponseType, ResponseError } from '../../@types/records';
import { jsonb as JsonbType } from '../../@types/jsonb';
import { DrawPolygonType } from '../../components/MapContent';
import Colors from '../../components/Colors';
import { loadJsonbStorage, loadFilterOps } from './utils';
import { filter } from 'lodash';
import { getFilterDates } from '../../actions/managementActions';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';

interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}

const initialRecordsResponse: RecordsResponseType = {
  count: 0,
  next: '',
  previous: '',
  results: [],
};

const initialResponseMessage: ResponseError = {
  details: '',
};

const ReviseLocation: React.FC = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(true);
  // Armazenando
  const [records, setRecords] = useState<RecordsResponseType>(initialRecordsResponse);
  // mensagem de erro
  const [responseMessage, setResponseMessage] = useState<ResponseError>(
    initialResponseMessage,
  );
  const [dateMin, setDateMin] = useState<string>(
    `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`,
  );
  const [dateMax, setDateMax] = useState<string>(
    `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`,
  );
  // Carregando os Sinistros de Acordo com a Data no LocalStorage e Transforma cada item em um Jsonb

  // Armazenando todos os Jsonb carregados na variavel jsonb
  const [jsonb, setJsonb] = useState<JsonbType>(loadJsonbStorage());

  // Armazenando todos os Jsonb carregados na variavel jsonb
  const [tablePage, setTablePage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [pageOffset, setPageOffset] = useState<number>(0);

  const [bboxPolygon, setBboxPolygon] = useState<{}>({});
  const [position, setPosition] = useState<LatLngTuple>([0, 0]);
  const [zoom, setZoom] = useState<number>(0);

  const [address, setAddress] = useState<string>('');
  const [requester, setRequester] = useState<string>('');

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);

  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');
  const [loadingDate, setloadingDate] = useState<boolean>(true);
  const [snackbar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });

  const [boundaryPolygon, setBoundaryPolygon] = useState<{}>({
    polygon_id: loadFilterOps().bairros,
  });
  const [drawPolygon, setDrawPolygon] = useState<DrawPolygonType | {}>(
    loadFilterOps().drawPolygon,
  );

  // Pegando as Opções de Filtragem e Amarzenando na FilterOps
  const filterOps: IncFilterOpsType = loadFilterOps();

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  const fetchManagementDate = useCallback(async () => {
    setloadingDate(true);
    try {
      const dates = await getFilterDates(filterOps.startDate, filterOps.endDate);
      setDateMin(dates.dateMin);
      setDateMax(dates.dateMax);
      setStartDateMap(dates.startDateMap);
      setEndDateMap(dates.endDateMap);
    } catch (error) {
      console.log(error);
    } finally {
      setloadingDate(false);
    }
  }, [filterOps.endDate, filterOps.startDate]);

  // Efetua a requisição para coletar os dados com a filtragem passada pelo FilterBar
  const fetchData = useCallback(async () => {
    setLoading(true);
    console.log('filter: ' + filterOps.endDate);
    console.log('dateMax: ' + dateMax);
    setResponseMessage({
      details: '',
    });
    await api
      .get('/api/incident_records/inaccurate_incidents/', {
        headers: { Authorization: `Token ${localStorage.getItem('auth')}` },
        params: {
          limit: rowsPerPage,
          offset: pageOffset,
          occurred_min: filterOps.startDate || dateMin,
          occurred_max: filterOps.endDate || dateMax,
          ...jsonb,
          ...boundaryPolygon,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setRecords(response.data as RecordsResponseType);
        }
      })
      .catch((error) => {
        if (error.response) {
          setResponseMessage(error.response.data.detail);
        }
      });
    setLoading(false);
  }, [
    dateMin,
    dateMax,
    rowsPerPage,
    pageOffset,
    jsonb,
    boundaryPolygon,
    filterOps.endDate,
    filterOps.startDate,
  ]);

  useEffect(() => {
    fetchManagementDate();
  }, [fetchManagementDate]);

  // Após Carregar as Datas, efetua a requisição de coletar o dados
  useEffect(() => {
    if (!loadingDate) {
      fetchData();
    }
  }, [loadingDate, fetchData]);

  const handleChangePage = (event: unknown, newPage: number) => {
    newPage < tablePage
      ? setPageOffset((prev) => prev - rowsPerPage)
      : setPageOffset((prev) => prev + rowsPerPage);

    setTablePage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageOffset(0);
    setTablePage(0);
  };

  return (
    <>
      {/* FilterBar passando todos os parâmetros de filtragem ao Jsonb */}
      <FilterBar
        filterJson={setJsonb}
        dateMaxSet={setDateMax}
        dateMinSet={setDateMin}
        setPositionSearch={setPosition}
        zoom={setZoom}
        id_boundary={setBoundaryPolygon}
        bbox_boundary={setBboxPolygon}
        routeTo="imprecisos"
        startDateMap={startDateMap}
        endDateMap={endDateMap}
        drawPolygon={drawPolygon}
        setDrawPolygon={setDrawPolygon}
        address={address}
        setAddress={setAddress}
        requester={requester}
        setRequester={setRequester}
        onFilter={() => {
          setTablePage(0);
          setPageOffset(0);
        }}
      />
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : responseMessage.details != '' ? (
        <h1 className={classes.errorText}>{responseMessage}</h1>
      ) : (
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell
                  className={classes.responsive}
                  style={{ color: Colors.tertiary }}
                >
                  Data e Hora
                </TableCell>
                <TableCell style={{ color: Colors.tertiary }}>Endereço</TableCell>

                <TableCell
                  className={classes.responsive}
                  style={{ color: Colors.tertiary }}
                >
                  Endereço Original
                </TableCell>
                <TableCell
                  className={classes.responsive}
                  style={{ color: Colors.tertiary }}
                >
                  Tipo Localização
                </TableCell>

                <TableCell
                  className={classes.responsive}
                  style={{ color: Colors.tertiary }}
                ></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {records.results.map((value) => (
                <TableRow key={value.uuid} hover>
                  <TableCell className={classes.responsive}>
                    {`${format(new Date(value.occurred_from), 'dd MMMM, yyyy, HH:mm', {
                      locale: ptBR,
                    })}`}
                  </TableCell>
                  <TableCell style={{ width: 'fit-content' }}>
                    {value.location_text}
                  </TableCell>

                  <TableCell className={classes.responsive}>
                    {value.data.driverIncidenteDetails['Endereço Original']}
                  </TableCell>

                  <TableCell className={classes.responsive}>
                    {value.data.driverIncidenteDetails['Location Type']}
                  </TableCell>

                  <TableCell>
                    <div className={classes.buttonsCol}>
                      {(publicGroup || geofi || tecEng) && !(admin || typist) ? null : (
                        <a
                          href={`/editar/impreciso/${value.uuid}`}
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'black' }}
                        >
                          <Button
                            size="small"
                            variant="outlined"
                            className={classes.button}
                          >
                            Editar
                          </Button>
                        </a>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                {/* Quantidade de itens na página */}
                <TablePagination
                  rowsPerPageOptions={[25, 50]}
                  rowsPerPage={rowsPerPage}
                  count={records.count}
                  page={tablePage}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                  }}
                  labelRowsPerPage={<span>Linhas por página</span>}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count}`
                  }
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default ReviseLocation;
